'use strict';

/** @type {import('.')} */
module.exports = Error;



//////////////////
// WEBPACK FOOTER
// ./~/es-errors/index.js
// module id = 416
// module chunks = 0